import React from "react";

const FeaturesSection = () => {
  // Helper function to convert YouTube URL to embed format
  const convertToEmbedUrl = (url) => {};
  const youtubeUrl = "https://www.youtube.com/watch?v=dQw4w9WgXcQ"; 
  const embedUrl = convertToEmbedUrl(youtubeUrl);

  return (
    <>
      <div className="top-feature">
        <div className="container">
          <div className="col-lg-12 col-12 mt-5">
            <div
              className="hero-video wow fadeInRight"
              data-wow-delay="0.3s"
              style={{
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "fadeInRight",
              }}
            >
              <div className="video-container">
                <div className="video-glow"></div>
                <div className="video-badge">▶ WATCH NOW</div>
                <div className="video-wrapper">
                  <iframe
                    src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
          <style jsx>{`
            .banner-description {
              font-size: 1.1rem;
              color: #e0e0e0;
              max-width: 800px;
              margin: 0 auto;
              line-height: 1.6;
            }

            .video-container {
              max-width: 750px;
              width: 95%;
              margin: 0 auto;
              background: linear-gradient(135deg, #101128 0%, #05051e 100%);
              padding: 20px;
              border-radius: 20px;
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
              transform: perspective(1000px) rotateY(-5deg);
              transition: all 0.3s ease;
              box-sizing: border-box;
            }
            .video-container:hover {
              transform: perspective(1000px) rotateY(0deg) scale(1.02);
              box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
            }
            .video-wrapper {
              position: relative;
              padding-bottom: 56.25%;
              height: 0;
              overflow: hidden;
              border-radius: 15px;
              background: #000;
            }
            .video-wrapper iframe {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 15px;
              border: none;
            }
            .video-placeholder {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 300px;
              background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
              border-radius: 15px;
              color: white;
              font-size: 18px;
              font-weight: 500;
            }
            .hero-video {
              max-width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 300px;
              width: 100%;
              text-align: center;
              margin: 0 auto;
              padding: 0 10px;
              box-sizing: border-box;
            }
            .video-badge {
              position: absolute;
              top: -10px;
              right: -10px;
              background: #ff4757;
              color: white;
              padding: 5px 15px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: bold;
              z-index: 10;
              box-shadow: 0 5px 15px rgba(255, 71, 87, 0.3);
            }
            .video-glow {
              position: absolute;
              top: -50%;
              left: -50%;
              width: 200%;
              height: 200%;
              background: radial-gradient(
                circle,
                rgba(102, 126, 234, 0.1) 0%,
                transparent 70%
              );
              pointer-events: none;
              animation: pulse 3s ease-in-out infinite;
            }
            @keyframes pulse {
              0%,
              100% {
                opacity: 0.5;
                transform: scale(1);
              }
              50% {
                opacity: 1;
                transform: scale(1.1);
              }
            }
            /* Mobile Styles - Fixes for mobile responsiveness */
            @media (max-width: 768px) {
              .video-container {
                position: relative;
                width: 90%;
                max-width: 90%;
                transform: none;
                margin: 20px auto;
                margin-top: 30px;
              }
              .video-container:hover {
                transform: none;
                scale: 1;
              }
              .video-placeholder {
                height: 200px;
                font-size: 16px;
              }
              .hero-video {
                min-height: 220px;
                margin-top: 30px;
                padding: 0 5px;
              }
              .video-badge {
                top: -8px;
                right: -8px;
                padding: 4px 12px;
                font-size: 11px;
              }
              .video-wrapper {
                padding-bottom: 56.25%;
              }
              .banner-description {
                font-size: 1rem;
                padding: 0 15px;
              }
            }
            /* Extra small screens */
            @media (max-width: 480px) {
              .video-container {
                padding: 15px;
                margin: 15px auto;
                margin-top: 20px;
                border-radius: 15px;
                width: 85%;
                max-width: 85%;
              }
              .video-placeholder {
                height: 180px;
                font-size: 14px;
                padding: 10px;
                text-align: center;
              }
              .hero-video {
                min-height: 200px;
                padding: 0;
              }
              .video-wrapper {
                border-radius: 10px;
              }
              .video-badge {
                top: -6px;
                right: -6px;
                padding: 3px 10px;
                font-size: 10px;
              }
            }
            /* Very small screens */
            @media (max-width: 360px) {
              .video-container {
                padding: 10px;
                margin: 10px auto;
                width: 80%;
                max-width: 80%;
              }
              .video-placeholder {
                height: 160px;
                font-size: 13px;
              }
              .hero-video {
                min-height: 180px;
                padding: 0;
              }
            }
          `}</style>
        </div>
        {/*END CONTAINER */}
      </div>
    </>
  );
};

export default FeaturesSection;
